<template>
  <div class="vote-result-box">
    <div class="d-flex align-items-center justify-content-between mb-2">
      <strong>Vote Result</strong>
      <CButton size="sm" color="danger" variant="outline" @click="$emit('close')">
        ✖
      </CButton>
    </div>

    <div v-if="resultData && resultData.length" class="vote-list">
      <div
          v-for="(item, index) in resultData"
          :key="index"
          class="d-flex justify-content-between py-1 border-bottom"
      >
        <span>{{ item.name }}</span>
        <strong>{{ item.votes }} votes</strong>
      </div>
    </div>
    <div v-else class="text-muted small">No vote data available</div>
  </div>
</template>

<script>
export default {
  name: 'VoteResult',
  props: {
    resultData: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>
.vote-result-box {
  width: 100%;
  padding: 1rem;
  background-color: #fff8e1;
  border: 1px solid #ffe082;
  border-radius: 12px;
  margin-top: 1rem;
}
</style>
